export default __webpack_public_path__ + "static/media/trading.f8c8fc31.webp";